import snakeCaseKeys from "snakecase-keys"
import pluralize from "pluralize"

import { BaseModel } from "./SohoApi"

const excludedKeys = ['id', 'type', 'relationships']

function serialize<T extends BaseModel = {}>(body: T): JsonApi.NewResourceObject<Partial<T>> {
  const { id, type } = body

  if (!type) {
    throw 'Requires TYPE in the resource'
  }

  const snakedBody = snakeCaseKeys(body as {})

  const attributes: Partial<T> = Object.entries(snakedBody).reduce((attrs: Partial<T>, [key, val]: any[]) => {
    if (!excludedKeys.includes(key)) {
      return {
        ...attrs,
        [key]: val
      }
    }

    return attrs
  }, {})

  // For existing objects
  if (id) {
    return {
      id,
      type: pluralize(type),
      attributes
    }
  }

  let relationships = {}

  if (body.relationships) {
    relationships = Object.entries(body.relationships).reduce((currentRelationships, [key, val]) => {
      if (val) {
        const { id, type } = val

        return {
          ...currentRelationships,
          [key]: {
            data: {
              id,
              type: pluralize(type as string)
            }
          }
        }
      }

      return currentRelationships
    }, {})
  }

  // For new objects
  return {
    type: pluralize(type),
    attributes,
    relationships
  }
}

export default serialize
